import {entitySave, executeCall} from './CallService';

export const crewSave = async(dbValues) => {
    return entitySave("crew", dbValues);
}

export const crewAndTeamList = async () => {
    const action = "query.dml";
    const data = {query: "crewAndTeamList"};
    return await executeCall(action, data);
}

export const crewLogin = async (loginValues) => {
    const action = "userLogin";
    const data = {
        query: "login",
        params: loginValues
    };
    return await executeCall(action, data);
}

export const crewPwChange = async (pwChangeValues) => {
    const action = "userPwChange";
    const data = {
        query: "pwChange",
        params: pwChangeValues
    };
    return await executeCall(action, data);
}